var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModalPerson = function SvgModalPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 293,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "modal-person_svg__b",
    width: 333,
    height: 327,
    x: 73,
    y: -110,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#modal-person_svg__a)",
    d: "M73.927-110H406v326.482H73.927z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#modal-person_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "modal-person_svg__d",
    width: 333,
    height: 327,
    x: 73,
    y: -110,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#modal-person_svg__c)",
    d: "M73.927-110H406v326.482H73.927z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.118,
    mask: "url(#modal-person_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 161.005,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 146.47,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 131.935,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 117.399,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 102.864,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 88.329,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 72.676,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 58.141,
    fill: "#161616",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 43.605,
    fill: "url(#modal-person_svg__e)",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 30.188,
    fill: "#2B2B2B",
    stroke: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 235.491,
    cy: 51.564,
    r: 24.598,
    fill: "#424242",
    stroke: "#5F5F5F"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.677,
    d: "M236.05 51.285a3.634 3.634 0 1 0 0-7.268 3.634 3.634 0 0 0 0 7.268ZM230.289 60.23h11.522c1.277 0 2.261-1.098 1.664-2.227-.877-1.661-2.876-3.644-7.425-3.644-4.548 0-6.548 1.983-7.425 3.644-.596 1.129.388 2.226 1.664 2.226Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "modal-person_svg__a",
    x1: 239.964,
    x2: 239.964,
    y1: -89.315,
    y2: 156.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "modal-person_svg__e",
    x1: 235.491,
    x2: 235.491,
    y1: 7.399,
    y2: 95.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "modal-person_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 163.241 -166.036 0 239.964 53.241)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
export default SvgModalPerson;